// src/js/config/ui/renderConfigurationTable.js

import { DOMElements } from '../dom.js';

/**
 * Renderar den detaljerade konfigurationstabellen på ordersidan.
 * @param {Object} configData - Det kompletta konfigurationsobjektet som ska visas.
 */
export function renderConfigurationTable(configData) {
    const { showConfigurationTable } = DOMElements;
    if (!showConfigurationTable) {
        console.error("Behållaren för konfigurationstabellen (#show-configuration-table) hittades inte.");
        return;
    }
    const tbody = showConfigurationTable.querySelector('tbody');
    if (!tbody) {
        console.error("Tbody-elementet inuti konfigurationstabellen hittades inte.");
        return;
    }

    // Om vi får null, rensa tabellen och avsluta.
    if (!configData) {
        tbody.innerHTML = '';
        return;
    }

    // Hämta de globala "ritningarna" och "ordböckerna" som matats in av PHP.
    const structure = window.SimP_Config_Structure || [];
    const map = window.SimP_Config_Map || {};
    const features = configData.features || {};
    const configType = configData.type || 'standard';

    // Bestäm språk från HTML-taggen för att visa rätt översättning.
    const lang = document.documentElement.lang.startsWith('sv') ? 'sv' : 'en';

    let tableHtml = '';

    // Filtrera "ritningen" för att bara visa relevanta rader
    const rowsToRender = structure.filter(row => {
        if (row.is_planned) return false;
        if (configType === 'standard' && row.is_flex) return false;
        if (row.type !== 'space' && !map[row.id]) {
            console.warn(`Rad med id "${row.id}" hoppades över eftersom den saknas i configurator-map.`);
            return false;
        }
        return true;
    });

    // Loopa igenom den filtrerade listan för att bygga HTML-rader
    rowsToRender.forEach(rowInfo => {
        const id = rowInfo.id;
        const metadata = map[id] || {};

        switch (rowInfo.type.toLowerCase()) {
            case 'header':
                const headerText = metadata[`name_${lang}`] || metadata.name_en;
                tableHtml += `
                    <tr class="repeat-header">
                        <th colspan="2">${headerText}</th>
                    </tr>`;
                break;

            case 'space':
                tableHtml += `<tr class="spacer"><td colspan="2"></td></tr>`;
                break;

            case 'data':
                const name = metadata[`name_${lang}`] || '';
                const specifier = metadata[`specifier_${lang}`] || '';
                const value = features[id];

                const nameHtml = `
                    <td>
                        <span class="column-1-left-side ${rowInfo.common_class}-left">${name}</span>
                        <span class="column-1-right-side ${rowInfo.common_class}-right">${specifier}</span>
                    </td>`;

                let valueHtml = '<td>';
                if (rowInfo.row_behavior === 'single') {
                    const checkedClass = value === true ? 'checked' : '';
                    valueHtml += `<div class="checkbox-graphic ${checkedClass}"><span class="checkmark"></span></div>`;
                } else {
                    valueHtml += `<span class="feature-value-placeholder">${value || 0}</span>`;
                }
                valueHtml += '</td>';

                tableHtml += `<tr data-feature-id="${id}">${nameHtml}${valueHtml}</tr>`;
                break;
        }
    });

    tbody.innerHTML = tableHtml;
}